import Config from "../constants/Config.js";
import { wordpressFetch } from "./index";
import { AddToCartType } from "../types";

export const cartGetState = (): Promise<any> => {
    let url = `${Config.shopAPI}/cart`;
    return wordpressFetch("GET", url);
};

export const cartClearState = (): Promise<any> => {
    let url = `${Config.shopAPI}/cart`;
    return wordpressFetch("DELETE", url);
};

export const addToCart = (addToCartPayload: AddToCartType): Promise<any> => {
    let url = `${Config.shopAPI}/cart/items`;
    return wordpressFetch("POST", url, null, addToCartPayload);
};

export const removeFromCart = (cartItemId: string): Promise<any> => {
    let url = `${Config.shopAPI}/cart/remove-item?key=${cartItemId}`;
    return wordpressFetch("POST", url);
};

export const applyCoupon = (code: string): Promise<any> => {
    let url = `${Config.shopAPI}/cart/apply-coupon?code=${code}`;
    return wordpressFetch("POST", url);
};

export const removeCoupon = (code: string): Promise<any> => {
    let url = `${Config.shopAPI}/cart/remove-coupon?code=${code}`;
    return wordpressFetch("POST", url);
};

export const selectShippingRate = (
    package_id: number = 0,
    rate_id: string
): Promise<any> => {
    let url = `${Config.shopAPI}/cart/select-shipping-rate`;
    return wordpressFetch("POST", url, null, {
        package_id,
        rate_id,
    });
};

export const quickRegistration = (customerDetails: {}): Promise<any> => {
    let url = `${Config.shopAPI}/cart/quick-registration`;
    return wordpressFetch("POST", url, null, customerDetails);
};

export const updateCustomer = (customerDetails: {}): Promise<any> => {
    let url = `${Config.shopAPI}/cart/update-customer`;
    return wordpressFetch("POST", url, null, customerDetails);
};

export const getPaymentOptions = (): Promise<any> => {
    let url = `${Config.shopAPI}/cart/payment-options`;
    return wordpressFetch("GET", url, null);
};

export const paypalCreateOrder = (requestObject: {}): Promise<any> => {
    let url = `${Config.shopAPI}/cart/paypal/create-order`;
    return wordpressFetch("POST", url, null, requestObject);
};

export const paypalApproveOrder = (
    ppcAproveOrderNonce: string,
    paypalOrderId: string
): Promise<any> => {
    let url = `${Config.shopAPI}/cart/paypal/approve-order`;
    return wordpressFetch("POST", url, null, {
        nonce: ppcAproveOrderNonce,
        order_id: paypalOrderId,
    });
};

export const paypalPaidOrder = (paypalOrderId: string): Promise<any> => {
    let url = `${Config.shopAPI}/cart/paypal/paid`;
    return wordpressFetch("POST", url, null, {
        token: paypalOrderId,
    });
};

export const getEventRegistrations = (
    orderId: number,
    token: string
): Promise<any> => {
    let url = `${Config.shopAPI}/tickets?token=${token}&order_id=${orderId}`;
    return wordpressFetch("GET", url, null);
};

export const checkoutOrder = (checkoutOrderObject: {}): Promise<any> => {
    let url = `${Config.shopAPI}/cart/checkout`;
    return wordpressFetch("POST", url, null, checkoutOrderObject);
};

export const payOrder = (securedCardData: string, recaptchaToken: string): Promise<any> => {
    let url = `${Config.shopAPI}/cart/eway/pay`;
    return wordpressFetch("POST", url, null, {
        secured_card_data: securedCardData,
        recaptcha_token: recaptchaToken,
    });
};

const cart = {
    cartGetState,
    cartClearState,
    addToCart,
    removeFromCart,
    applyCoupon,
    removeCoupon,
    selectShippingRate,
    quickRegistration,
    updateCustomer,
    getPaymentOptions,
    paypalCreateOrder,
    paypalApproveOrder,
    paypalPaidOrder,
    checkoutOrder,
    payOrder,
};

export default cart;
